export default __webpack_public_path__ + "static/media/S-024.024cd3be.png";